import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import type { ThinLineFlag } from '../../hooks/useThinLineCheck';

interface ThinLineWarningBannerProps {
  flags: ThinLineFlag[];
  onSeeDetails: () => void;
}

// Mounted in DesignerApp.tsx between SideSelector and the canvas — matches
// the client-provided FastEditor reference screenshot's own layout (a full-
// width amber banner directly above the canvas, "See details" opening a
// modal). Renders nothing when there's nothing to flag (useThinLineCheck.ts
// already gates this per-side, including the Full Color exemption).
export function ThinLineWarningBanner({ flags, onSeeDetails }: ThinLineWarningBannerProps) {
  const { t } = useTranslation();
  if (flags.length === 0) return null;

  return (
    <div
      role="alert"
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '10px 16px',
        background: '#fef3c7',
        borderLeft: '4px solid #f59e0b',
        borderBottom: '1px solid #fde68a',
      }}
    >
      <AlertTriangle size={16} style={{ color: '#b45309', flexShrink: 0 }} />
      <span style={{ fontSize: 13, color: '#92400e', flex: 1 }}>
        {t('thinLine.bannerMessage')}
      </span>
      <button
        onClick={onSeeDetails}
        style={{
          fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 6,
          border: 'none', background: '#f59e0b', color: 'white', cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        {t('thinLine.seeDetails')}
      </button>
    </div>
  );
}
